import { TY_CROSS_SELL_URL } from '../constant';
export interface TYCrossSellSuccessData {
  status: 'SUCCESS';
  response: {
    title: string;
    description: string;
    image_urls: string[];
    show_widget: boolean;
    show_bottomsheet: boolean;
    autoshow_bottomsheet_timeout: number;
    redirection_timeout: number;
    redirection_message: string;
    widget_cta: string;
    bottomsheet_skip_cta: string;
    deeplink: string;
    bottomsheet_deeplink: string;
    deeplink_data?: string;
    bottomsheet_view_cabs_cta?: string;
    coupon_text?: string;
    persuasion?: {
      icon: string;
      text: string;
      bg_color: string;
    };
    images_dimension?:{
      width: number;
      height: number;
    }
    show_coupon_inline_widget?: boolean;
    show_coupon_bottomsheet_widget?: boolean;
    show_persuasion_inline_widget?: boolean;
    show_persuasion_bottomsheet_widget?: boolean;
  };
}

interface TYCrossSellErrorData {
  status: 'ERROR';
}

type TYCrossSellData = TYCrossSellSuccessData | TYCrossSellErrorData;

export const getTYCrossSellData = async ({
  fromStation,
  toStation,
  arrivalDate,
  arrivalTime,
  isRailTransferEnabled,
}: {
  fromStation: string;
  toStation: string;
  arrivalDate: string;
  arrivalTime: string;
  isRailTransferEnabled: boolean;
}): Promise<TYCrossSellData> => {
  const newHeader = {
    "Content-Type": "application/json",
    "x-gommt-brand": "MMT",
    "x-app-platform": "mweb",
  };
  const headers = new Headers(newHeader);
  const requestParams = {
    from_station: fromStation,
    to_station: toStation,
    arrival_date: arrivalDate,
    arrival_time: arrivalTime,
    is_rail_transfer: isRailTransferEnabled.toString(),
  };

  const url = `${TY_CROSS_SELL_URL}?${new URLSearchParams(requestParams).toString()}`;
  const request = new Request(url, {
    method: "GET",
    headers,
  });
  const response = await fetch(request, { credentials: "include" });
  const data = await response.json();
  return data?.data;
};
